import { updateAppChatState } from "@ch/redux-store/chat/actions";
import * as Sentry from "@sentry/react";
import { usePostHog } from "posthog-js/react";
import { useDispatch } from "react-redux";
import { useChatSocketContext } from "../utils/chatSocketProvider/ChatSocketContext";
import logoutUser from "../utils/logoutUser";

const useLogout = () => {
  const { goOffline } = useChatSocketContext();
  const dispatch = useDispatch();

  const postHog = usePostHog();

  const logout = () => {
    postHog.reset();

    Sentry.setUser(null);

    goOffline();
    dispatch(
      updateAppChatState({
        unreadMessages: [],
        onlineMembers: [],
      }),
    );

    logoutUser();
  };
  return {
    logoutUser: logout,
  };
};

export default useLogout;
